module.exports = __webpack_public_path__ + "static/media/inInputClose.56369429.svg";